import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ThreeDots } from 'react-loader-spinner';
import SftGlobalData from '../library/globalData';
import SearchCard from '../cards/SearchCard';
import './SearchScreen.css';

function SearchScreen({ isLoggedIn, language }) {
    const { query } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!isLoggedIn) {
            navigate(`/${language}/`);
            return;
        }

        if (query) {
            performSearch(decodeURIComponent(query));
        }
    }, [query, isLoggedIn, language]);

    const performSearch = async (searchTerm) => {
        setLoading(true);

        const response = await SftGlobalData.post('docs&action=searchChangeLog', {
            language: String(language).toUpperCase(),
            search: searchTerm
        });

        console.log('Search response:', response);

        if (response.success && response.data) {
            // Flatten the grouped response: each application contains versions array
            const groupedData = Array.isArray(response.data) ? response.data : [];
            const flatResults = [];

            groupedData.forEach(appGroup => {
                if (appGroup.versions && Array.isArray(appGroup.versions)) {
                    appGroup.versions.forEach(version => {
                        flatResults.push({
                            ...version,
                            application: appGroup.application
                        });
                    });
                }
            });

            console.log('Search results (flattened):', flatResults);
            setResults(flatResults);
        } else {
            setResults([]);
        }

        setLoading(false);
    };

    const handleCardClick = (docId) => {
        navigate(`/${language}/document/${docId}`);
    };

    if (!isLoggedIn) {
        return null;
    }

    if (loading) {
        return (
            <div className="search-screen loading">
                <ThreeDots color="#28A9E0" height={60} width={60} />
            </div>
        );
    }

    return (
        <div className="search-screen">
            <h1>{t('search')}</h1>
            {query && <p className="search-query">"{decodeURIComponent(query)}"</p>}

            {results.length === 0 ? (
                <p className="no-results">{t('noResults')}</p>
            ) : (
                <div className="search-results">
                    {results.map((result, index) => (
                        <SearchCard
                            key={result.doc_id || index}
                            result={result}
                            language={language}
                            onClick={() => handleCardClick(result.doc_id)}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}

export default SearchScreen;
